import { useEffect } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import RadioButton from "@shared/v2/RadioButton";
import * as actions from "../actions/creators";
import * as thunks from "../actions/thunks";

import AgentSelector from "./AgentSelector";
import PondSelector from "./PondSelector";

import useConnectWindowCallback from "../helpers/hooks";

const mapStateToProps = (state) => ({
  tab: state.leadRouting.tab,
  show: state.leadRouting.show,
  leadRuleId: state.leadRouting.leadRuleId,
  selectedAgents: state.leadRouting.selectedAgents,
  selectedPond: state.leadRouting.selectedPond,
  saving: state.leadRouting.isSaving,
  saved: state.leadRouting.isSaved,
});

const AGENT_TAB = "agents";

const TargetSelector = ({
  tab,
  show,
  leadRuleId,
  selectedAgents,
  selectedPond,
  saveForm,
  saving,
  saved,
  setModalData,
  showModal,
  selectTab,
  reset,
}) => {
  useConnectWindowCallback({ setModalData, showModal });

  const canSave = (tab === AGENT_TAB && selectedAgents?.length) || selectedPond;
  useEffect(() => {
    if (saved) {
      window.location.reload();
      reset();
    }
  }, [saved]);
  return (
    <Modal
      show={show}
      onHide={reset}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[600px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title="Add Agent" closeButton />
      <Modal.Body>
        <div className="tw-flex tw-gap-[32px] tw-mb-[8px]">
          <RadioButton
            value={AGENT_TAB}
            label="Agent"
            checked={tab === AGENT_TAB}
            onClick={() => selectTab(AGENT_TAB)}
          />
          <RadioButton
            value="pond"
            label="Lead Pond"
            checked={tab !== AGENT_TAB}
            onClick={() => selectTab("pond")}
          />
        </div>
        {tab === AGENT_TAB ? <AgentSelector /> : <PondSelector />}
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={reset}>
          Cancel
        </Button>
        <Button
          disabled={!canSave}
          isLoading={saving}
          size="medium"
          schema="primary"
          onClick={() => saveForm({ leadRuleId, tab, selectedAgents, selectedPond })}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default connect(mapStateToProps, { ...actions, ...thunks })(TargetSelector);

TargetSelector.propTypes = {
  tab: Proptypes.string,
  show: Proptypes.bool,
  leadRuleId: Proptypes.number,
  selectedAgents: Proptypes.arrayOf(Proptypes.shape({})),
  selectedPond: Proptypes.shape({}),
  saveForm: Proptypes.func,
  saving: Proptypes.bool,
  saved: Proptypes.bool,
  setModalData: Proptypes.func,
  showModal: Proptypes.func,
  selectTab: Proptypes.func,
  reset: Proptypes.func,
};

TargetSelector.defaultProps = {
  tab: null,
  show: false,
  leadRuleId: null,
  selectedAgents: null,
  selectedPond: null,
  saveForm: null,
  saving: null,
  saved: false,
  setModalData: null,
  showModal: null,
  selectTab: null,
  reset: null,
};
